import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '../shared/services/permission.service';

@Pipe({
    name: 'profilpipe',
    standalone: false
})
export class ProfilPipe implements PipeTransform {
  public permissions: any;

  constructor(private service: PermissionService) {
    this.service.getPermissionsList().subscribe((data) => {
      this.permissions = data;
    });
  }

  transform(id: string): any {
    return this.service.getValue(id, this.permissions);
  }
}
